import { Link, Route, Routes, useLocation } from "react-router-dom";
import Index from "./pages/index";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './assect/scss/style.scss'
import './assect/css/materialdesignicons.min.css'
import './assect/css/container.css'
import Footer from "./components/footer";
import ScrollTop from "./components/scrollTop";
import IndexTwo from "./pages/index/index-two"
import IndexThree from "./pages/index/index-three";
import IndexFour from "./pages/index/index-four";
import IndexFive from "./pages/index/index-five";
import IndexSix from "./pages/index/index-six";
import IndexSeven from "./pages/index/index-seven";
import Buy from "./pages/buy";
import Sell from "./pages/sell";
import Grid from "./pages/listing/grid";
import GridSidebar from "./pages/listing/grid-sidebar";
import List from "./pages/listing/list";
import ListSidebar from "./pages/listing/list-sidebar";
import PropertyDetails from "./pages/listing/property-detail";
import PropertyDetailsTwo from "./pages/listing/property-detail-two";
import Features from "./pages/features";
import Pricing from "./pages/pricing";
import Faqs from "./pages/faqs";
import Terms from "./pages/terms";
import Privacy from "./pages/privacy";
import Blogs from "./pages/blogs";
import BlogSidebar from "./pages/blog-sidebar";
import BlogDetail from "./pages/blog-detail";
import AuthLogin from "./pages/auth/auth-login";
import ResetPassword from "./pages/auth/auth-re-password";
import Signup from "./pages/auth/auth-signup";
import Comingsoon from "./pages/Special/comingsoon";
import Maintenance from "./pages/Special/maintenance";
import Error from "./pages/Special/error";

// KEEP THESE PAGES
import DiscoverTroy from "./pages/discovertroy";
import PropertyListing from "./pages/propertylisting"
import Furnished from "./pages/furnished";
import AboutUs from "./pages/aboutus";
import ContactUs from "./pages/contactus";
import Apply from "./pages/apply";
import Login from "./pages/login";
import PropertyDetail from "./pages/listing/propertydetail";
import React from "react";
import GeneralInformation from "./pages/generalinformation";
import LeasingProcess from "./pages/leasingprocess";
import HemlaneEmbed from "./components/hemlaneembed";
import ReactGA from 'react-ga4';
import PageTracker from './components/pageTracker'
import AdminPanel from "./components/adminPanel";
import ProtectedAdminRoute from "./utills/ProtectedAdminRoutes";
import BlogView from "./components/blogView";
import BlogLandingPage from "./components/detailedBlogView";

function App() {
  const location = useLocation()
  return (
    <>
      {/* PageTracker for analytics */}
      <PageTracker />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/index-two" element={<IndexTwo />} />
        <Route path="/index-three" element={<IndexThree />} />
        <Route path="/index-four" element={<IndexFour />} />
        <Route path="/index-five" element={<IndexFive />} />
        <Route path="/index-six" element={<IndexSix />} />
        <Route path="/index-seven" element={<IndexSeven />} />
        <Route path="/buy" element={<Buy />} />
        <Route path="/sell" element={<Sell />} />
        <Route path="/grid" element={<Grid />} />
        <Route path="/grid-sidebar" element={<GridSidebar />} />
        <Route path="/list" element={<List />} />
        <Route path="/list-sidebar" element={<ListSidebar />} />
        <Route path="/property-detail" element={<PropertyDetails />} />
        <Route path="/property-detail/:id" element={<PropertyDetails />} />
        <Route path="/property-detail-two" element={<PropertyDetailsTwo />} />

        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        {/* <Route path="/blogs" element={<Blogs />} /> */}
        <Route path="/blog-sidebar" element={<BlogSidebar />} />
        <Route path="/blog-detail" element={<BlogDetail />} />
        <Route path="/blog-detail/:id" element={<BlogDetail />} />

        <Route path="/auth-login" element={<AuthLogin />} />
        <Route path="/auth-signup" element={<Signup />} />
        <Route path="/auth-reset-password" element={<ResetPassword />} />
        <Route path="/comingsoon" element={<Comingsoon />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/error" element={<Error />} />

        {/*KEEP THESE ROUTES*/}

        <Route path="/propertylisting" element={<PropertyListing />} />
        <Route path="/furnished" element={<Furnished />} />
        <Route path="/contactus/:propertyId?" element={<ContactUs />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/login" element={<Login />} />
        <Route path="/discovertroy" element={<DiscoverTroy />} />
        <Route path="/my-property-detail/:id" element={<PropertyDetail />} />
        <Route path="*" element={<Error />} />

        <Route
          path="/adminPanel"
          element={
            <ProtectedAdminRoute>
              <AdminPanel />
            </ProtectedAdminRoute>
          }
        />

        {/*BLOG ROUTES*/}
        <Route path="/blogs" element={<BlogView />} />
        <Route path="/blog/:slug" element={<BlogLandingPage />} />

        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/generalinformation" element={<GeneralInformation />} />
        <Route path="/leasingprocess" element={<LeasingProcess />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/hemlaneembed" element={<HemlaneEmbed />} />
      </Routes>
      <ScrollTop />
    </>
  );
}

export default App;
